import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    notConfigured: {
        height: '95%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: theme.typography.size.l,
        fontWeight: theme.typography.fontWeightRegular,
    },
    notConfiguredIcon: {
        '& img': {
            height: theme.spacing(5),
        },
    },
    '#widget-content-height': {
        // height: '100%',
        /* fontWeight: theme.typography.fontWeightRegular, */
        border: '1px solid red',
    },
}));

export default useStyles;
